<template>
  <v-card class="text-start text--secondary pa-4 text-body-2" flat>
    <p class="" style="white-space:pre-wrap;">
      These Software Terms of Use (”<strong>Terms of Use</strong>”) govern your use of the
      Beyond Labz software (the “<strong>Software</strong>”), including all user manuals,
      technical manuals, and any other materials provided by Licensor, in printed, electronic,
      or other form, that describe the Software or its use or specifications (the
      “<strong>Documentation</strong>”) provided to you (”<strong>you</strong>” or
      “<strong>your</strong>”) for use pursuant to and subject to a software subscription
      agreement (the “<strong>Software Subscription Agreement</strong>”) between Beyond Labz,
      Inc. (”<strong>Licensor</strong>”) and your school or other organization or entity through
      which you use the Software (”<strong>Licensee</strong>”).</p>
    <p class="" style="white-space:pre-wrap;">BY CLICKING THE “ACCEPT” BUTTON YOU: (i)
      REPRESENT THAT YOU ARE DULY AUTHORIZED BY LICENSEE TO ACCESS AND USE THE SOFTWARE; AND
      (ii) ACCEPT THESE AUTHORIZED USER TERMS AND AGREE THAT YOU ARE LEGALLY BOUND BY THEM. IF
      YOU DO NOT AGREE TO THESE TERMS OF USE, DO NOT CLICK THE “ACCEPT” BUTTON AND YOU WILL
      HAVE NO LICENSE TO, AND MUST NOT ACCESS OR USE, THE SOFTWARE.</p>
    <p class="" style="white-space:pre-wrap;">License Grant. Subject to your strict compliance
      with these Terms of Use, Licensor hereby grants you a non-exclusive, non-transferable,
      non-sublicensable, limited license to use the Software solely in accordance with the
      Documentation and for educational purposes. The foregoing licensee will terminate
      immediately on the earlier to occur of:</p>
    <ol data-rte-list="default"><ol data-rte-list="default">
      <li><p class="" style="white-space:pre-wrap;">the expiration or earlier termination of
        the Software Subscription agreement between Licensor and Licensee;&nbsp;</p></li>
      <li><p class="" style="white-space:pre-wrap;">one year from the date you first accept
        these terms of use; or</p></li><li><p class="" style="white-space:pre-wrap;">your
      ceasing to be authorized by Licensee to use the Software for any or no reason.
    </p></li></ol></ol>
    <p class="" style="white-space:pre-wrap;">Use Restrictions. You shall not, directly or
      indirectly:</p>
    <ol data-rte-list="default">
      <ol data-rte-list="default">
        <li>
          <p class="" style="white-space:pre-wrap;">use the Software or Documentation except as
            set forth in <span style="text-decoration:underline">Section 1</span>;
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
          copy the Software or Documentation, in whole or in part;
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
            modify, translate, adapt, or otherwise create derivative works or improvements,
            whether or not patentable, of the Software or any part thereof;
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
            combine the Software or any part thereof with, or incorporate the Software or any
            part thereof in, any other programs;
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
            reverse engineer, disassemble, decompile, decode, or otherwise attempt to derive or
            gain access to the source code of the Software or any part thereof;
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
            remove, delete, alter, or obscure any trademarks or any copyright, trademark,
            patent, or other intellectual property or proprietary rights notices included on or
            in the Software or Documentation, including any copy thereof;
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
            rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or
            otherwise provide any access to or use of the Software or any features or
            functionality of the Software, for any reason, to any other person or entity,
            including any subcontractor, independent contractor, affiliate, or service provider
            of Licensee, whether or not over a network and whether or not on a hosted basis,
            including in connection with the internet, web hosting, wide area network (WAN),
            virtual private network (VPN), virtualization, time-sharing, service bureau,
            software as a service, cloud, or other technology or service;
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
            use the Software or Documentation in violation of any law, regulation, or rule; or
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">
            use the Software or Documentation for purposes of competitive analysis of the
            Software, the development of a competing software product or service, or any other
            purpose that is to the Licensor’s commercial disadvantage.
          </p>
        </li>
      </ol>
    </ol>
    <p class="" style="white-space:pre-wrap;">
      Compliance Measures. The Software may contain technological copy protection or other
      security features designed to prevent unauthorized use of the Software, including features
      to protect against use of the Software:
    </p>
    <ol data-rte-list="default">
      <ol data-rte-list="default">
        <li>
          <p class="" style="white-space:pre-wrap;">
            beyond the scope of the license granted to pursuant to
            <span style="text-decoration:underline">Section 1</span>; or
          </p>
        </li>
        <li>
          <p class="" style="white-space:pre-wrap;">prohibited under
            <span style="text-decoration:underline">Section 2</span>.
          </p>
        </li>
      </ol>
    </ol>
    <p class="" style="white-space:pre-wrap;">You shall not, and shall not attempt to, remove,
      disable, circumvent, or otherwise create or implement any workaround to, any such copy
      protection or security features.
    </p>
    <p class="" style="white-space:pre-wrap;">
      Collection and Use of Information. Licensor may, directly or indirectly through the
      services of others, collect and store information about you, your use of the Software, and
      any equipment on which the Software is installed or through which it otherwise is accessed
      and used. Licensor’s collection and use of such information is subject to Licensor’s
      Privacy Policy, available at [LINK]. By accepting these terms of use, you acknowledge that
      you have read and agree to be bound by Licensor’s Privacy Policy.&nbsp;
    </p>
    <p class="" style="white-space:pre-wrap;">
      Intellectual Property Rights. You acknowledge that the Software is provided under license,
      and not sold, to you. You do not acquire any ownership interest in the Software under this
      Agreement, or any other rights to the Software other than to use the Software in
      accordance with the license granted under this Agreement, subject to all terms,
      conditions, and restrictions. Licensor reserves and shall retain its entire right, title,
      and interest in and to the Software and all intellectual property rights arising out of or
      relating to the Software, subject to the license expressly granted to the Licensee in this
      Agreement. You shall safeguard all Software (including all copies thereof) from
      infringement, misappropriation, theft, misuse, or unauthorized access.
    </p>
    <p class="" style="white-space:pre-wrap;">
      Disclaimer of Liability. IN NO EVENT WILL LICENSOR OR ITS AFFILIATES, OR ANY OF ITS OR
      THEIR RESPECTIVE LICENSORS OR SERVICE PROVIDERS, BE LIABLE TO YOU FOR ANY USE,
      INTERRUPTION, DELAY, OR INABILITY TO USE THE SOFTWARE. YOU ARE PROVIDED THE SOFTWARE
      PURSUANT TO THE SOFTWARE SUBSCRIPTION AGREEMENT BETWEEN LICENSOR AND LICENSEE, SOLELY FOR
      THE BENEFIT OF LICENSEE AND AT LICENSEE’S DISCRETION. YOU ACKNOWLEDGE THAT YOU HAVE NO
      RIGHTS UNDER THAT AGREEMENT INCLUDING ANY RIGHTS TO ENFORCE ANY OF ITS TERMS. ANY
      OBLIGATION OR LIABILITY LICENSOR OR ITS AFFILIATES, OR ANY OF ITS OR THEIR LICENSORS OR
      SERVICE PROVIDERS, MAY HAVE WITH RESPECT TO YOUR USE OR INABILITY TO USE THE SOFTWARE
      SHALL BE SOLELY TO LICENSEE PURSUANT TO THAT AGREEMENT AND SUBJECT TO ALL LIMITATIONS OF
      LIABILITY SET FORTH THEREIN.
    </p>
    <p class="" style="white-space:pre-wrap;">
      Export Regulation. The Software may be subject to US export control laws, including the US
      Export Administration Act and its associated regulations. You shall not, directly or
      indirectly, export, re-export, or release the Software to, or make the Software or
      Documentation accessible from, any jurisdiction or country to which export, re-export, or
      release is prohibited by law, rule, or regulation. You shall comply with all applicable
      federal laws, regulations, and rules, and complete all required undertakings (including
      obtaining any necessary export license or other governmental approval), prior to
      exporting, re-exporting, releasing, or otherwise making the Software available outside the
      US.
    </p>
    <p class="" style="white-space:pre-wrap;">
      Governing Law. These Terms of Use are governed by and construed in accordance with the
      internal laws of the State of Utah without giving effect to any choice or conflict of law
      provision or rule (whether of the State of Utah or any other jurisdiction) that would
      cause the application of Laws of any jurisdiction other than those of the State of Utah.
    </p>
  </v-card>
</template>

<script>
export default {
  name: 'TermsOfUse',
};
</script>
